export const themes = ['default',
    'default_repocard',
    'dark',
    'radical',
    'merko',
    'gruvbox',
    'tokyonight',
    'onedark',
    'cobalt',
    'synthwave',
    'highcontrast',
    'dracula',
    'prussian',
    'monokai',
    'vue',
    'vue-dark',
    'shades-of-purple',
    'nightowl',
    'buefy',
    'blue-green',
    'algolia',
    'great-gatsby',
    'darcula',
    'bear',
    'solarized-dark',
    'solarized-light',
    'chartreuse-dark',
    'nord',
    'gotham',
    'material-palenight',
    'graywhite',
    'vision-friendly-dark',
    'ayu-mirage',
    'midnight-purple',
    'calm',
    'flag-india',
    'omni',
    'react',
    'jolly',
    'maroongold',
    'yeblu',
    'blueberry-light',
    'blueberry-dark',
    'slateorange',
    'kacho_ga',
    'blood',
    'blood-dark'];
export const animations = ['default', 'grow_out_in'];
export const layouts = ['default', 'samuel', 'churchill', 'socrates', 'zues', 'minimal', 'terminal', 'neon', 'newspaper', 'polaroid'];
export const fonts = [
  'default',
  'Gabrielle',
  'Redressed',
  'Calligraffitti',
  'Architect',
  'PixelifySans'
];
export const colorValues = [
  "red",
  "blue",
  "green",
  "yellow",
  "purple",
  "orange",
  "black",
  "white",
  "pink",
  "brown",
  "gray",
  "cyan",
  "magenta",
  "indigo",
  "teal",
  "lavender",
  "maroon",
  "coral",
  "gold",
  "silver",
  "lime",
  "olive",
  "turquoise",
  "violet",
  "beige",
  "navy",
  "plum",
  "salmon",
  "skyblue",
  "mintgreen"
];
export const quoteTypes = ['random', 'quote-for-the-day'];
